export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-02.03e5e9f3.jpg";